export default __webpack_public_path__ + "static/media/top.22ff8595.svg";